import RentList from './RentList';

function App() {
  const isStaging = process.env.REACT_APP_ENV === "staging";

  return (
    <>
      {isStaging && (
        <div
          style={{
            position: "fixed",
            top: 10,
            left: 10,
            background: "#ff4444",
            color: "white",
            padding: "4px 10px",
            fontSize: "18px",
            fontWeight: "bold",
            zIndex: 9999,
            borderRadius: "4px"
          }}
        >
          STAGING
        </div>
      )}

      <RentList />
    </>
  );
}

export default App;
